import React, { useContext, useEffect, useState } from 'react'
import { Fragment } from 'react';
import { AuthContext } from '../../../App/App';
import { HelpdeskContext } from './Helpdesk';
import { ContentBodyContext } from '../MainContent';
import jwt from 'jwt-decode'


function ChatHeaderStatus() {
    const { stateContentBody, dispatchContentBody } = useContext(ContentBodyContext);
    const { stateHelpdesk, dispatchHelpdesk } = useContext(HelpdeskContext);
    const { stateAuth, dispatchAuth } = useContext(AuthContext);

    // status change
    const handleChange = (event) => {
        updateStatus(event.target.value)
    }

    const updateStatus = (statusId) => {
        stateContentBody.socket.emit(`helpdesk-user-feedback-close`, {
            token: localStorage.getItem('token-helpdesk-umy'),
            data: {
                admin: jwt(localStorage.getItem('token-helpdesk-umy')).status,
                chat_id: stateHelpdesk.active,
                sender: 'admin',
                action: statusId == 3 ? 'close' : 'update',
                status_id: statusId,
                workunit: { id: jwt(localStorage.getItem('token-helpdesk-umy')).work_unit_id, name: stateContentBody.workunitName, acronym: stateContentBody.workunitAcronym },
                user: stateHelpdesk.chats.find(chat => chat.complaint_id == stateHelpdesk.active)
            }
        })

        if (statusId == 3) {
            dispatchHelpdesk({
                type: 'ACTIVE',
                active: null
            })
        } else {
            dispatchHelpdesk({
                type: 'TRIGGER',
                trigger: { message: 'reload-status' }
            })
        }
    }

    const [renderStatus, setrenderStatus] = useState(<div className="col-6 col align-self-end "></div>)
    useEffect(() => {
        if ((stateHelpdesk.active != null) && (stateHelpdesk.filterSub != "done" || stateHelpdesk.filter != "admin" || stateHelpdesk.trigger.message == 'reload-status') && stateHelpdesk.chats.length > 0) {
            const status = stateHelpdesk.chats.find(chat => chat.complaint_id == stateHelpdesk.active).status

            const isDisabled = (param) => {
                if (status == 4) {
                    return false
                } else if ((status == 2 && param == 4) || (status == 1 && param == 4)) {
                    return true
                } else if (status == 3 && param != 3) {
                    return false
                } else {
                    return false
                }
            }
            setrenderStatus(
                <div className="col-6 col align-self-end ">
                    <div className="row col-12  p-0 m-0">
                        <div className="form-group pl-4 pr-4 pt-1 m-0 col-auto">
                            <small className="mr-0 ml-0 sm-2"><b>Status</b></small>
                        </div>
                        <div className="form-group p-0 m-0 col-8" style={{ "width": "100%", float: 'right' }}>
                            <select value={status} className="form-control form-select ml-0 mr-sm-2" onChange={handleChange}>
                                <option key="4" disabled={isDisabled(4)} value="4" >New Message</option>
                                <option key="1" disabled={isDisabled(1)} value="1" >Process</option>
                                <option key="2" disabled={isDisabled(2)} value="2" >Pending</option>
                                <option key="3" disabled={isDisabled(3)} value="3" >Done</option>
                            </select >
                        </div>
                    </div>
                    <div className="row justify-content-center col-12 p-0 m-0">
                        <small className="col-auto" style={{ color: 'red', fontSize: '0.7em' }}>
                            *If your message is complete,assign status to "Done".
                        </small>
                    </div>
                </div>
            )
        } else {
            setrenderStatus(<div className="col-6 col align-self-end "></div>)
        }
    }, [stateHelpdesk.active, stateHelpdesk.trigger])

    return (renderStatus)
}

export default ChatHeaderStatus
